/**
  * теперь этот файл/поток будет кодироваться в UTF-8
*/
import 'element-ui/lib/theme-chalk/index.css';
import "../app/dist/manifest.js";
import "../app/dist/index.js";

export class Builder {
	start(rootNode, params) {
		document.Platform.Dashboard(document.querySelector(rootNode), params)
	}
}